/*  ========================================================================
    # Sections - Values Slider
    ========================================================================  */

import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useSwipeable } from 'react-swipeable';
import useLocalization from '@/react/hooks/useLocalization';
import useTranslation from '@/react/hooks/useTranslation';
import LazyImage from '@/react/components/LazyImage';
import LazySource from '@/react/components/LazySource';

const ValuesSlider = ({ headline, values }) => {
  const [activeSlide, setActiveSlide] = useState(0);
  const __ = useTranslation();

  // Icons
  const localize = useLocalization();
  const iconChevronLeft = `${localize('svgSprite')}#angle-left`;
  const iconChevronRight = `${localize('svgSprite')}#angle-right`;

  // Navigate Left
  const navigateLeft = () => {
    if (activeSlide > 0) {
      setActiveSlide(activeSlide - 1)
    } else {
      setActiveSlide(values.length - 1);
    }
  };

  // Navigate Right
  const navigateRight = () => {
    if (activeSlide < values.length - 1) {
      setActiveSlide(activeSlide + 1)
    } else {
      setActiveSlide(0)
    };
  };

  const getDataOffset = index => {
    if (activeSlide === index) {
      return 0
    } else if (activeSlide + 1 == index || activeSlide === values.length - 1 && index === 0) {
      return 1
    } else {
      return -1
    }
  }

  const swipeHandlers = useSwipeable({
    onSwipedLeft: navigateRight,
    onSwipedRight: navigateLeft
  });

  return (
    <>
      <div className="container">
        {headline &&
          <div className="s-values-slider__headline wysiwyg-block"
            dangerouslySetInnerHTML={{ __html: headline }}>
          </div>}
        <div className="s-values-slider__wrapper">
          <div className="s-values-slider__items-wrapper" {...swipeHandlers}>
            {values.map((value, index) => (
              <div className='s-values-slider__item' key={index} data-offset={getDataOffset(index)}>
                <div className="s-values-slider__content wysiwyg-block" dangerouslySetInnerHTML={{ __html: value.content }} />
                {value.image ?
                  <div className="s-values-slider__content-image">
                    <LazyImage
                      defaultUrl={value.image['sizes']['medium_large']}
                      placeholderUrl={value.image['sizes']['thumbnail']}
                      alt={value.image['alt']}
                    >
                      <LazySource srcSet={value.image['sizes']['medium_large']} mediaMin='992px' />
                    </LazyImage>
                  </div>
                  : null}
              </div>
            ))}
            <div className='s-values-slider__controls'>
              <button type='button' title={__('section-values-navigate-left')} className='c-button c-button--icon' onClick={() => navigateLeft()}>
                <svg viewBox='0 0 24 24'>
                  <use href={iconChevronLeft} />
                </svg>
              </button>
              <button type='button' title={__('section-values-navigate-right')} className='c-button c-button--icon' onClick={() => navigateRight()}>
                <svg viewBox='0 0 24 24'>
                  <use href={iconChevronRight} />
                </svg>
              </button>
            </div>
          </div>
          <div className="s-values-slider__icons">
            {values.map((value, index) => (
              <div className="s-values-slider__icon" data-offset={getDataOffset(index)} dangerouslySetInnerHTML={{ __html: value.icon }} key={index} onClick={() => setActiveSlide(index)} />
            ))}
          </div>
        </div>
      </div>
    </>
  );
};

ValuesSlider.propTypes = {
  headline: PropTypes.string,
  values: PropTypes.array
};

export default ValuesSlider;
